module.exports = __webpack_public_path__ + "img/2.71de1a5e.svg";